// ===== Desktop navigation: click to expand =====
// The theme's native component uses hover. Stop those hover events before they
// reach the component, while keeping the mobile touch behavior unchanged.
document.addEventListener('DOMContentLoaded', function () {
  const desktopNavigation = window.matchMedia('(min-width: 750px)');
  const dropdownTrigger = window.headerNavigationConfig?.dropdownTrigger || 'click';
  const menus = document.querySelectorAll('hover-disclosure');

  function isDesktopMenu(menu) {
    return dropdownTrigger === 'click' && desktopNavigation.matches && menu.matches('hover-disclosure');
  }

  function closeMenu(menu) {
    menu.dispatchEvent(new CustomEvent('theme:disclosure:hide', { bubbles: false }));
  }

  function closeOtherMenus(currentMenu) {
    menus.forEach(function (menu) {
      if (menu !== currentMenu && menu.getAttribute('aria-expanded') === 'true') {
        closeMenu(menu);
      }
    });
  }

  ['mouseenter', 'mouseleave'].forEach(function (eventName) {
    document.addEventListener(eventName, function (event) {
      if (isDesktopMenu(event.target)) {
        event.stopImmediatePropagation();
      }
    }, true);
  });

  menus.forEach(function (menu) {
    const trigger = menu.querySelector('[data-top-link]');
    if (!trigger) return;

    trigger.addEventListener('click', function (event) {
      if (!isDesktopMenu(menu)) return;

      // A top-level item with a dropdown is a menu control in click mode,
      // so it must never follow its link.
      event.preventDefault();

      if (menu.getAttribute('aria-expanded') !== 'true') {
        closeOtherMenus(menu);
        menu.dispatchEvent(new CustomEvent('theme:disclosure:show', { bubbles: false }));
      } else {
        closeMenu(menu);
      }
    });
  });

  document.addEventListener('click', function (event) {
    if (dropdownTrigger !== 'click' || !desktopNavigation.matches || event.target.closest('hover-disclosure')) return;
    closeOtherMenus(null);
  });

  document.addEventListener('keydown', function (event) {
    if (dropdownTrigger === 'click' && desktopNavigation.matches && event.key === 'Escape') {
      closeOtherMenus(null);
    }
  });
});



// ===== Highlight Sub-nav item color =====

(function () {
    if (!window.subNavHighlightConfig) return;

    const settingText = window.subNavHighlightConfig.items;
    const highlightColor = window.subNavHighlightConfig.color;

    if (!settingText) return;

    const items = settingText
        .split(",")
        .map(i => i.trim().toLowerCase())
        .filter(Boolean);

    document.querySelectorAll("header a").forEach(link => {
        const text = link.textContent
        .replace(/\s+/g, " ")
        .trim()
        .toLowerCase();

        if (items.includes(text)) {
        link.style.setProperty("color", highlightColor, "important");

        link.querySelectorAll("span").forEach(span => {
            span.style.setProperty("color", highlightColor, "important");
        });
        }
    });
})();



// ===== Change header image on hover ofon menu items =====

document.addEventListener("mouseover", function (e) {
    const link = e.target.closest("a.link-over-image");
    if (!link) return;

    const imgUrl = link.dataset.hoverImage;
    if (!imgUrl) return;

    const dropdown = link.closest(".header__dropdown");
    if (!dropdown) return;

    const images = dropdown.querySelectorAll(".header__dropdown__image img");

    images.forEach(img => {
        // save defaults once
        if (!img.dataset.defaultSrc) {
        img.dataset.defaultSrc = img.getAttribute("src");
        img.dataset.defaultSrcset = img.getAttribute("srcset");
        img.dataset.defaultSizes = img.getAttribute("sizes");
        }

        // force browser to use THIS image
        img.setAttribute("src", imgUrl);
        img.setAttribute("srcset", imgUrl);
        img.setAttribute("sizes", "100vw");
    });
});

document.addEventListener("mouseout", function (e) {
    const link = e.target.closest("a.link-over-image");
    if (!link) return;

    const dropdown = link.closest(".header__dropdown");
    if (!dropdown) return;

    const images = dropdown.querySelectorAll(".header__dropdown__image img");

    images.forEach(img => {
        if (!img.dataset.defaultSrc) return;

        img.setAttribute("src", img.dataset.defaultSrc);

        if (img.dataset.defaultSrcset) {
        img.setAttribute("srcset", img.dataset.defaultSrcset);
        } else {
        img.removeAttribute("srcset");
        }

        if (img.dataset.defaultSizes) {
        img.setAttribute("sizes", img.dataset.defaultSizes);
        } else {
        img.removeAttribute("sizes");
        }
    });
});


// ===== Remove style number from product title [Wiser App] =====

setInterval(function(){
    document.querySelectorAll('.ws-widget-section .ws-product-title-link').forEach(function(el){
        if(!el.classList.contains('title-fixed')){
        var title = el.textContent;
        var newTitle = title.split('|').pop().trim();

        el.textContent = newTitle;
        el.classList.add('title-fixed');
        }
    });
},1000);



// ===== Fix Firefox issue: return user to the same product after going back =====

$(document).on('click', '.collection .product', function () {
    const index = $(this).index();
    sessionStorage.setItem('plpIndex', index);
});

function restorePLPScroll() {
    const index = sessionStorage.getItem('plpIndex');
    if (index === null) return;

    const interval = setInterval(function () {
        const $products = $('.collection .product');

        if ($products.length > index) {
        clearInterval(interval);

        const $target = $products.eq(index);

        if ($target.length) {
            $('html, body').scrollTop($target.offset().top - 100);
        }

        sessionStorage.removeItem('plpIndex');
        }
    }, 100);
}

$(document).ready(function () {
    restorePLPScroll();
});
